export default [
  {
    id: 'skill_point',
    title: 'Pilot Skill Trigger',
    detail: "{INC_DEC} the Pilot's total available Skill selections by {VAL}",
  },
  {
    id: 'mech_skill_point',
    title: 'Mech Skill (HASE) Point',
    detail: "{INC_DEC} the Pilot's total available HULL/AGI/SYS/ENG selections by {VAL}",
  },
  {
    id: 'talent_point',
    title: 'Pilot Talent',
    detail: "{INC_DEC} the Pilot's total available Talent selections by {VAL}",
  },
  {
    id: 'license_point',
    title: 'Pilot License',
    detail: "{INC_DEC} the Pilot's total available License selections by {VAL}",
  },
  {
    id: 'cb_point',
    title: 'Pilot CORE Bonus',
    detail: "{INC_DEC} the Pilot's total available CORE Bonus selections by {VAL}",
  },
  {
    id: 'pilot_gear_slots',
    title: 'Pilot Gear Capacity',
    detail: "{INC_DEC} the Pilot's total available Pilot Gear capacity by {VAL}",
  },
    {
    id: 'pilot_weapon_slots',
    title: 'Pilot Weapon Capacity',
    detail: "{INC_DEC} the Pilot's total available Pilot Weapon capacity by {VAL}",
  },
  {
    id: 'range',
    title: 'Modified Weapon Range',
    detail:
      '{INC_DEC} weapon {RANGE_TYPES} by {VAL} for{DAMAGE_TYPES}{WEAPON_TYPES}{WEAPON_SIZES} weapons',
  },
  {
    id: 'damage',
    title: 'Modified Weapon Damage',
    detail: '{INC_DEC}{DAMAGE_TYPES}weapon damage by {VAL} for{WEAPON_TYPES}{WEAPON_SIZES} weapons',
  },
  {
    id: 'hp',
    title: 'Mech HP',
    detail: '{INC_DEC} total Mech Hit Points by {VAL}',
  },
  {
    id: 'armor',
    title: 'Mech Armor',
    detail: '{INC_DEC} total Mech Armor by {VAL}',
  },
  {
    id: 'structure',
    title: 'Mech Structure',
    detail: '{INC_DEC} total Mech Structure by {VAL}',
  },
  {
    id: 'stress',
    title: 'Mech Reactor Stress',
    detail: '{INC_DEC} total Mech Reactor Stress by {VAL}',
  },
  {
    id: 'heatcap',
    title: 'Mech Heat Capacity',
    detail: '{INC_DEC} total Mech Heat Capacity by {VAL}',
  },
  {
    id: 'repcap',
    title: 'Mech Repair Capacity',
    detail: '{INC_DEC} total Mech Repair Capacity by {VAL}',
  },
  {
    id: 'core_power',
    title: 'Mech CORE Power',
    detail: '{INC_DEC} total Mech CORE Power by {VAL}',
  },
  {
    id: 'speed',
    title: 'Mech Speed',
    detail: '{INC_DEC} total Mech Speed by {VAL}',
  },
  {
    id: 'evasion',
    title: 'Mech Evasion',
    detail: '{INC_DEC} total Mech Evasion by {VAL}',
  },
  {
    id: 'edef',
    title: 'Mech E-Defense',
    detail: '{INC_DEC} total Mech E-Defense by {VAL}',
  },
  {
    id: 'sensor',
    title: 'Mech Sensor Range',
    detail: '{INC_DEC} total Mech Sensor Range by {VAL}',
  },
  {
    id: 'tech_attack',
    title: 'Mech Tech Attack',
    detail: '{INC_DEC} total Mech Tech Attack by {VAL}',
  },
  {
    id: 'save',
    title: 'Mech Save',
    detail: '{INC_DEC} total Mech Save by {VAL}',
  },
  {
    id: 'sp',
    title: 'Mech SP',
    detail: '{INC_DEC} total Mech System Points by {VAL}',
  },
  {
    id: 'size',
    title: 'Modified Mech Size',
    detail: '{INC_DEC} Mech Size by {VAL}',
  },
  {
    id: 'ai_cap',
    title: 'AI Capacity',
    detail: '{INC_DEC} total Mech AI Capacity by {VAL}',
  },
  {
    id: 'cheap_struct',
    title: 'Half Cost for Structure Repairs',
    detail: 'Structure repairs cost 1 Repair instead of 2',
  },
  {
    id: 'cheap_stress',
    title: 'Half Cost for Reactor Stress Repairs',
    detail: 'Reactor repairs cost 1 Repair instead of 2',
  },
  {
    id: 'overcharge',
    title: 'Modified Overcharge Track',
    detail: 'Modifies the Overcharge Heat Cost track',
  },
  {
    id: 'limited_bonus',
    title: 'Limited Equipment Uses',
    detail: '{INC_DEC} the total uses of Equipment with the "LIMITED X" Tag by {VAL}',
  },
  {
    id: 'pilot_hp',
    title: 'Pilot HP',
    detail: '{INC_DEC} total Pilot Hit Points by {VAL}',
  },
  {
    id: 'pilot_armor',
    title: 'Pilot Armor',
    detail: '{INC_DEC} total Pilot Armor by {VAL}',
  },
  {
    id: 'pilot_evasion',
    title: 'Pilot Evasion',
    detail: '{INC_DEC} total Pilot Evasion by {VAL}',
  },
  {
    id: 'pilot_edef',
    title: 'Pilot E-Defense',
    detail: '{INC_DEC} total Pilot E-Defense by {VAL}',
  },
  {
    id: 'pilot_speed',
    title: 'Add Pilot Speed',
    detail: '{INC_DEC} total Pilot Speed by {VAL}',
  },
  {
    id: 'deployable_hp',
    title: 'HP for all Drones and Deployables',
    detail: '{INC_DEC} the total HP of all deployed Deployables by {VAL}',
  },
  {
    id: 'deployable_size',
    title: 'Size for all Drones and Deployables',
    detail: '{INC_DEC} the Size of all deployed Deployables by {VAL}',
  },
  {
    id: 'deployable_charges',
    title: 'Charges for all Drones and Deployables',
    detail: '{INC_DEC} the total available Charges for Drone and Deployable Equipment by {VAL}',
  },
  {
    id: 'deployable_armor',
    title: 'Armor for all Drones and Deployables',
    detail: '{INC_DEC} the Armor of all deployed Deployables by {VAL}',
  },
  {
    id: 'deployable_evasion',
    title: 'Evasion for all Drones and Deployables',
    detail: '{INC_DEC} the Evasion of all deployed Deployables by {VAL}',
  },
  {
    id: 'deployable_edef',
    title: 'E-Defense for all Drones and Deployables',
    detail: '{INC_DEC} the E-Defense of all deployed Deployables by {VAL}',
  },
  {
    id: 'deployable_heatcap',
    title: 'Heat Capacity for all Drones and Deployables',
    detail: '{INC_DEC} the Heat Capacity of all deployed Deployables by {VAL}',
  },
  {
    id: 'deployable_repcap',
    title: 'Repair Capacity for all Drones and Deployables',
    detail: '{INC_DEC} the Repair Capacity of all deployed Deployables by {VAL}',
  },
  {
    id: 'deployable_sensor_range',
    title: 'Sensor Range for all Drones and Deployables',
    detail: '{INC_DEC} the Sensor Range of all deployed Deployables by {VAL}',
  },
  {
    id: 'deployable_tech_attack',
    title: 'Tech Attack for all Drones and Deployables',
    detail: '{INC_DEC} the Tech Attack of all deployed Deployables by {VAL}',
  },
  {
    id: 'deployable_save',
    title: 'Save for all Drones and Deployables',
    detail: '{INC_DEC} the Save of all deployed Deployables by {VAL}',
  },
  {
    id: 'deployable_speed',
    title: 'Speed for all Drones and Deployables',
    detail: '{INC_DEC} the Speed of all deployed Deployables by {VAL}',
  },
  {
    id: 'drone_hp',
    title: 'HP for all Drones',
    detail: '{INC_DEC} the total HP of all deployed Drones by {VAL}',
  },
  {
    id: 'drone_size',
    title: 'Size for all Drones',
    detail: '{INC_DEC} the Size of all deployed Drones by {VAL}',
  },
  {
    id: 'drone_charges',
    title: 'Charges for all Drones',
    detail: '{INC_DEC} the total available Charges for Drone and Deployable Equipment by {VAL}',
  },
  {
    id: 'drone_armor',
    title: 'Armor for all Drones',
    detail: '{INC_DEC} the Armor of all deployed Drones by {VAL}',
  },
  {
    id: 'drone_evasion',
    title: 'Evasion for all Drones',
    detail: '{INC_DEC} the Evasion of all deployed Drones by {VAL}',
  },
  {
    id: 'drone_edef',
    title: 'E-Defense for all Drones',
    detail: '{INC_DEC} the E-Defense of all deployed Drones by {VAL}',
  },
  {
    id: 'drone_heatcap',
    title: 'Heat Capacity for all Drones',
    detail: '{INC_DEC} the Heat Capacity of all deployed Drones by {VAL}',
  },
  {
    id: 'drone_repcap',
    title: 'Repair Capacity for all Drones',
    detail: '{INC_DEC} the Repair Capacity of all deployed Drones by {VAL}',
  },
  {
    id: 'drone_sensor_range',
    title: 'Sensor Range for all Drones',
    detail: '{INC_DEC} the Sensor Range of all deployed Drones by {VAL}',
  },
  {
    id: 'drone_tech_attack',
    title: 'Tech Attack for all Drones',
    detail: '{INC_DEC} the Tech Attack of all deployed Drones by {VAL}',
  },
  {
    id: 'drone_save',
    title: 'Save for all Drones',
    detail: '{INC_DEC} the Save of all deployed Drones by {VAL}',
  },
  {
    id: 'drone_speed',
    title: 'Speed for all Drones',
    detail: '{INC_DEC} the Speed of all deployed Drones by {VAL}',
  },
]
